<p-confirmDialog />

<app-card-content [border]="false" icon="pi pi-history" title="Histórico" subtitle="Histórico do prestador">
    <div card-header><app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" /></div>
    <app-tab-container [(selected)]="selected" [options]="options" [useHeader]="false">
        <app-tab-content value="INSCRICOES">
            <app-custom-table
                [metadata]="metadata"
                [data]="linhasTabela()"
                [columnOrder]="['tipoInscricao', 'situacao', 'dataSituacao']"
                [rowStyle]="rowStyleHistorico"
                [loading]="loading()"
                [first]="first()"
                [totalRecords]="totalRecords()"
                [rows]="rows()"
                [showActions]="true"
                [initialViewMode]="'table'"
                [permissaoUf]="pessoa()?.uf ?? null"
                (onPageChange)="onPaginaAlterada($event)"
            />
            <div class="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
                <span class="font-semibold">Legenda:</span>
                <span class="inline-flex items-center gap-1"><span class="inline-block h-3 w-3 rounded-sm" style="background: #16a34a"></span> Atual</span>
                <span class="inline-flex items-center gap-1"><span class="inline-block h-3 w-3 rounded-sm" style="background: #dc2626"></span> Inscrições anteriores</span>
            </div>
        </app-tab-content>
        <app-tab-content value="PROTOCOLOS"><app-protocolos-prestador [pessoa]="pessoa()" /></app-tab-content>
        <app-tab-content value="FINANCEIRO"><app-informacoes-financeiras-prestador [pessoa]="pessoa()" /></app-tab-content>
        <app-tab-content value="CORRESPONDENCIAS"><app-correspondencias-prestador [pessoa]="pessoa()" /></app-tab-content>
    </app-tab-container>
</app-card-content>

<p-dialog
    appDialogoPadrao="pi pi-history"
    descricao="Corrija as datas de vínculo da gerida."
    [visible]="dialogVisivel()"
    (visibleChange)="aoAlterarVisibilidadeDialog($event)"
    [style]="{ width: 'min(94vw, 920px)' }"
    [appendTo]="'body'"
    header="Atualizar histórico de inscrição"
>
    <div class="flex flex-col gap-4">
        <app-card-content [headerColor]="true" icon="pi pi-id-card" title="Identificação">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
                <div>
                    <label class="font-semibold block mb-2">CRM</label>
                    <input pInputText [value]="pessoa()?.crm ?? pessoa()?.dadosGerais?.crm ?? ''" readonly class="w-full" />
                </div>
                <div>
                    <label class="font-semibold block mb-2">UF</label>
                    <input pInputText [value]="pessoa()?.uf ?? ''" readonly class="w-full" />
                </div>
                <div>
                    <label class="font-semibold block mb-2">Classificação</label>
                    <input pInputText [value]="pessoa()?.dadosGerais?.classificacao ?? ''" readonly class="w-full" />
                </div>
                <div>
                    <label class="font-semibold block mb-2">Razão social</label>
                    <input pInputText [value]="pessoa()?.nomes?.razaoSocial ?? pessoa()?.nome ?? ''" readonly class="w-full" />
                </div>
            </div>
        </app-card-content>

        <app-card-content [headerColor]="true" icon="pi pi-file-edit" title="Dados da inscrição">
            <div card-header>
                <p-button label="Novo" icon="pi pi-plus" size="small" severity="secondary" outlined (onClick)="novoRegistro()" [appCan]="roleHistoricoEditar" [appCanUf]="pessoa()?.uf" />
            </div>
            <form [formGroup]="formulario" class="grid grid-cols-1 gap-4 md:grid-cols-3">
                <div>
                    <label class="font-semibold block mb-2">Tipo de inscrição *</label>
                    <p-select formControlName="idTipoInscricao" [options]="tiposInscricao()" optionLabel="descricao" optionValue="id" [loading]="carregandoOpcoes()" appendTo="body" styleClass="w-full" (onChange)="aoAlterarTipoInscricao()" />
                </div>
                <div>
                    <label class="font-semibold block mb-2">Situação *</label>
                    <p-select formControlName="idSituacao" [options]="situacoes()" optionLabel="descricao" optionValue="id" [loading]="carregandoOpcoes()" appendTo="body" styleClass="w-full" />
                </div>
                <div>
                    <label class="font-semibold block mb-2">Data da situação *</label>
                    <input pInputText formControlName="dataSituacao" type="date" class="w-full" />
                </div>
            </form>
        </app-card-content>

        <app-card-content [headerColor]="false" icon="pi pi-history" title="Histórico de inscrições">
            <app-custom-table
                [metadata]="metadata"
                [data]="linhasTabela()"
                [columnOrder]="['tipoInscricao', 'situacao', 'dataSituacao', 'situacaoAtual']"
                [loading]="loading()"
                [first]="first()"
                [totalRecords]="totalRecords()"
                [rows]="rows()"
                [showActions]="true"
                [initialViewMode]="'table'"
                [permissaoUf]="pessoa()?.uf ?? null"
                (onPageChange)="onPaginaAlterada($event)"
            />
        </app-card-content>
    </div>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" (onClick)="aoAlterarVisibilidadeDialog(false)" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" [disabled]="formulario.invalid" (onClick)="salvarRegistro()" />
    </ng-template>
</p-dialog>
